import { useEffect, useState } from 'react';

import logout from 'domain/authentication/usecases/logout';

import delayed from 'utils/delayed';

const useLogoutPage = () => {
  const [isLoggingOut, setIsLoggingOut] = useState(true);
  const [hasLoggingOutFailed, setHasLoggingOutFailed] = useState(false);
  const [hasLoggedOut, setHasLoggedOut] = useState(false);

  useEffect(() => {
    if (!isLoggingOut) return;

    setHasLoggingOutFailed(false);

    const request = async () => {
      try {
        await delayed(logout());

        setIsLoggingOut(false);
        setHasLoggedOut(true);
      } catch (error) {
        setIsLoggingOut(false);
        setHasLoggingOutFailed(true);
      }
    };

    request();
  }, [isLoggingOut]);

  const retry = () => setIsLoggingOut(true);

  return { isLoggingOut, hasLoggingOutFailed, hasLoggedOut, retry };
};

export default useLogoutPage;
